import React from "react";
import {
  Box,
  MainCard,
  MainText,
  PressableOpacity,
} from "app/components/common";
import ArrowRightSlider from "app/components/Icons/ArrowSlider/ArrowRightSlider";
import theme from "app/Theme/Theme";
import normalize from "app/utils/normalize";
import { Platform } from "react-native";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";

export interface ISelectAnalysisTypeCardProps {
  onPressCard: () => void;
  icon: React.ReactNode;
  title: string;
  explanation: string;
}

const SelectAnalysisTypeCard = ({
  icon,
  title,
  explanation,
  onPressCard,
}: ISelectAnalysisTypeCardProps) => {
  return (
    <PressableOpacity onPress={onPressCard}>
      <Box
        shadowColor="shadow"
        backgroundColor="neutral.white"
        style={
          isWebDesktop && {
            "box-shadow": "0px 1px 31px rgba(189, 189, 189, 0.19)",
          }
        }
        borderRadius={8}
        shadowRadius={normalize(10)}
        elevation={normalize(2)}
        zIndex={1}
        borderWidth={Platform.OS === "android" ? 1 : 0}
        borderColor="neutral.200"
        flexDirection="row"
        justifyContent="flex-start"
        alignItems="center"
        padding="sm"
        position="relative"
        width="100%"
        shadowOpacity={1}
        shadowOffset={{
          height: normalize(4),
          width: 0,
        }}
        marginBottom="xm"
      >
        <Box
          marginRight="s"
          alignSelf="flex-start"
          justifyContent="flex-start"
          alignItems="center"
        >
          {icon}
        </Box>
        <Box
          width="100%"
          flexDirection="row"
          alignItems="center"
          justifyContent="center"
          flex={1}
        >
          <Box flexDirection="column" flex={1} marginRight="s">
            <MainText variant="l4-bold" numberOfLines={1}>
              {title}
            </MainText>
          </Box>
          <ArrowRightSlider color={theme.colors["brand.500"]} />
        </Box>
      </Box>
    </PressableOpacity>
  );
};

export default SelectAnalysisTypeCard;
